import { render, staticRenderFns } from "./NotAuthorizedLayout.vue?vue&type=template&id=24a532ae&"
import script from "./NotAuthorizedLayout.vue?vue&type=script&lang=js&"
export * from "./NotAuthorizedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a532ae')) {
      api.createRecord('24a532ae', component.options)
    } else {
      api.reload('24a532ae', component.options)
    }
    module.hot.accept("./NotAuthorizedLayout.vue?vue&type=template&id=24a532ae&", function () {
      api.rerender('24a532ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/NotAuthorizedLayout.vue"
export default component.exports